import { useLocation } from "react-router-dom";

export const useRouteChecks = () => {
  const location = useLocation();

  const inHeaderCheckRouter = {
    isHomePage: location.pathname === "/",
    isIntroFormPage: location.pathname === "/introForm",
    isMatchPage: location.pathname === "/match",
    isUserPage: location.pathname.includes("/users/"),
    isStreakPage: location.pathname === "/streak",
    isMatchSecondVersionPage: location.pathname === "/matchSecondVersion",
  };

  const inFooterCheckRouter = {
    isHomePage: location.pathname === "/",
    isIntroFormPage: location.pathname === "/introForm",
    isMatchPage: location.pathname === "/match",
    isUserPage: location.pathname.includes("/users/"),
    isStreakPage: location.pathname === "/streak",
    isMatchSecondVersionPage: location.pathname === "/matchSecondVersion",
  };

  return {
    inHeaderCheckRouter,
    inFooterCheckRouter,
    isHomePage: location.pathname === "/",
    isIntroFormPage: location.pathname === "/introForm",
    isMatchPage: location.pathname === "/match",
    isUserPage: location.pathname.includes("/users/"),
    isStreakPage: location.pathname === "/streak",
    isMatchSecondVersionPage: location.pathname === "/matchSecondVersion",
  };
};
